/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateProxiesRequest
 */
export interface GenerateProxiesRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof GenerateProxiesRequest
     */
    bundles?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GenerateProxiesRequest
     */
    directories?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GenerateProxiesRequest
     */
    proxyProfiles: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof GenerateProxiesRequest
     */
    enqueueAtFront?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenerateProxiesRequest
     */
    force?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GenerateProxiesRequest
     */
    retryFailed?: boolean;
}

export function GenerateProxiesRequestFromJSON(json: any): GenerateProxiesRequest {
    return GenerateProxiesRequestFromJSONTyped(json, false);
}

export function GenerateProxiesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateProxiesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bundles': !exists(json, 'bundles') ? undefined : json['bundles'],
        'directories': !exists(json, 'directories') ? undefined : json['directories'],
        'proxyProfiles': json['proxy_profiles'],
        'enqueueAtFront': !exists(json, 'enqueue_at_front') ? undefined : json['enqueue_at_front'],
        'force': !exists(json, 'force') ? undefined : json['force'],
        'retryFailed': !exists(json, 'retry_failed') ? undefined : json['retry_failed'],
    };
}

export function GenerateProxiesRequestToJSON(value?: GenerateProxiesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bundles': value.bundles,
        'directories': value.directories,
        'proxy_profiles': value.proxyProfiles,
        'enqueue_at_front': value.enqueueAtFront,
        'force': value.force,
        'retry_failed': value.retryFailed,
    };
}


